import script from "./PartnersPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnersPage.vue?vue&type=script&setup=true&lang=js"

import "./PartnersPage.vue?vue&type=style&index=0&id=bbb587f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbb587f8"]])

export default __exports__